export const LOCALE = {
  ZH: 'zh',
  EN: 'en',
};

export const EN_PREFIX = '/en';

/** 根据 pathname 判断当前语言 */
export const getLocaleFromPath = (pathname = '') => {
  if (pathname === EN_PREFIX || pathname.startsWith(`${EN_PREFIX}/`)) {
    return LOCALE.EN;
  }
  return LOCALE.ZH;
};

/** 去掉 /en 前缀，得到中文路径 */
export const stripEnPrefix = (pathname = '') => {
  if (pathname === EN_PREFIX) return '/';
  if (pathname.startsWith(`${EN_PREFIX}/`)) {
    return pathname.slice(EN_PREFIX.length) || '/';
  }
  return pathname;
};

/** 为路径添加 /en 前缀 */
export const addEnPrefix = (pathname = '') => {
  const bare = stripEnPrefix(pathname);
  if (bare === '/') return EN_PREFIX;
  return `${EN_PREFIX}${bare}`;
};

/** 按目标语言转换路径（用于中英文切换） */
export const switchLocalePath = (pathname = '', targetLocale = LOCALE.ZH) => {
  const currentLocale = getLocaleFromPath(pathname);

  // 跨语言切换：统一跳转到对应语言的首页
  if (currentLocale === LOCALE.ZH && targetLocale === LOCALE.EN) {
    return EN_PREFIX;
  }
  if (currentLocale === LOCALE.EN && targetLocale === LOCALE.ZH) {
    return '/';
  }

  const bare = stripEnPrefix(pathname);
  return targetLocale === LOCALE.EN ? addEnPrefix(bare) : bare;
};

/** 将路径本地化为当前语言 */
export const localizePath = (path = '/', locale = LOCALE.ZH) => {
  if (!path || typeof path !== 'string') return path;
  const [pathname, search = ''] = path.split('?');
  const hash = pathname.includes('#') ? pathname.slice(pathname.indexOf('#')) : '';
  const pathOnly = hash ? pathname.slice(0, pathname.indexOf('#')) : pathname;
  const hashPart = hash || (pathname.includes('#') ? '' : '');

  const localized =
    locale === LOCALE.EN ? addEnPrefix(pathOnly) : stripEnPrefix(pathOnly);

  return `${localized}${search ? `?${search}` : ''}${hashPart}`;
};

/** 详情/页面导航 — 中文 → 英文标签映射 */
export const NAV_LABEL_MAP_EN = {
  '公司简介': 'Company Profile',
  '投资者关系': 'Investor Relations',
  '视频展示': 'Video Showcase',
  '员工风采': 'Employee Gallery',
  '荣誉资质': 'Honors & Certifications',
  '联系我们': 'Contact Us',
  '公司新闻': 'Company News',
  '行业新闻': 'Industry News',
  '首页': 'Home',
  '关于信维': 'About Us',
  '新闻中心': 'News Center',
  '解决方案': 'Solutions',
};

/** 面包屑「您的位置」文案 */
export const getLocationLabel = (locale = LOCALE.ZH) =>
  locale === LOCALE.EN ? 'Your Location' : '您的位置';

/** 按当前语言翻译导航标签 */
export const translateNavLabel = (label, locale = LOCALE.ZH) => {
  if (!label || locale !== LOCALE.EN) return label;
  return NAV_LABEL_MAP_EN[label] || label;
};
